import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import {
  ShootAssetArchiveDialogComponent,
  ShootAssetArchiveDialogData,
} from 'src/app/components/home/batches/actions/shoot-asset-archive-dialog/shoot-asset-archive-dialog.component';

@Component({
  selector: 'app-export-shoot-assets-action',
  templateUrl: './export-shoot-assets-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ExportShootAssetsActionComponent implements OnInit {
  @Input() selectedProducts: IProduct[] = [];
  @Input() organizationId!: string;
  @Input() batchId!: string;
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.ShootAssetsDownload);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onExport(): void {
    const data: ShootAssetArchiveDialogData = {
      productIds: this.selectedProducts
        .map((product: IProduct) => product.id)
        .filter((id): id is string => id !== undefined && id !== null),
      organizationId: this.organizationId,
      batchId: this.batchId,
    };
    this.dialog.open(ShootAssetArchiveDialogComponent, {
      data,
      disableClose: true,
      width: '90vw',
      maxWidth: '1400px',
      maxHeight: '90vh',
      ariaLabelledBy: 'sasa-archive-title',
    });
  }
}
